export default __webpack_public_path__ + "static/media/AnimalMondey02_00.2778be30.png";